import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { useIntl } from '@grandvisionhq/state';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/fun-products';
import '@grandvisionhq/lib-visuals';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-monetate';
import '@swc/helpers';
import '@grandvisionhq/inventory';
import '@grandvisionhq/utils';
import { ProductDetailSpecificationContainer } from '../../../Components/ProductDetailSpecification/ProductDetailSpecificationContainer.js';
import '@grandvisionhq/reviews';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/frk-routing';
import { getContactLensFeatures } from '../../utils/get-contactlens-features.js';

const LensesSpecification = ()=>{
    const { getLabel  } = useIntl();
    const { activeVariant  } = useProductDetailContext();
    const { productFeatures  } = React.useMemo(()=>CommerceToolsApi.isLenses(activeVariant) ? getContactLensFeatures(activeVariant, getLabel) : {
            productFeatures: []
        }
    , [
        getLabel,
        activeVariant
    ]);
    return /*#__PURE__*/ React.createElement(ProductDetailSpecificationContainer, {
        fallbackConfiguration: productFeatures
    });
};

export { LensesSpecification };
//# sourceMappingURL=LensesSpecification.js.map
